export default __webpack_public_path__ + "static/media/red-med2.dd281a01.jpg";